<template>
  <el-form ref="form" :model="offRoadForm" :rules="rules" label-width="200px">
    <el-row>
      <el-col :span="8">
        <el-form-item label="检测报告编号" prop="report_id">
          <el-input v-model="offRoadForm.report_id" clearable placeholder="请输入检测报告编号" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">所有人或代理人信息</el-divider>
    </el-col>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名/单位" prop="machine_owner">
          <el-input v-model="offRoadForm.machine_owner" clearable placeholder="请输入姓名/单位" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="machine_owner_contact">
          <el-input v-model="offRoadForm.machine_owner_contact" clearable placeholder="请输入联系电话" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-form-item label="联系地址" prop="machine_owner_address">
        <el-col :span="8">
          <el-cascader
            v-model="offRoadForm.machine_owner_region"
            size="medium"
            :options="pcTextArr"
            style="width: 100%;"
          />
        </el-col>
        <el-col :span="8">
          <el-input v-model="offRoadForm.machine_owner_address" style="margin-left: 10px;" clearable placeholder="请输入详细地址" />
        </el-col>
      </el-form-item>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">非道路移动柴油机械基本信息</el-divider>
    </el-col>
    <el-row>
      <el-col :span="12">
        <el-form-item label="机械类型" prop="product_status">
          <el-input v-model="offRoadForm.product_status" clearable placeholder="请输入机械类型" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="机械型号" prop="model_specification">
          <el-input v-model="offRoadForm.model_specification" clearable placeholder="请输入机械型号" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="出厂年份" prop="manufacture_date">
          <el-date-picker
            v-model="offRoadForm.manufacture_date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择出厂年份"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="机械VIN" prop="machine_vin_serial">
          <el-input v-model="offRoadForm.machine_vin_serial" clearable placeholder="请输入机械VIN" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="生产厂名称" prop="manufacturer">
          <el-input v-model="offRoadForm.manufacturer" clearable placeholder="请输入生产厂名称" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="排放阶段" prop="emission_stage">
          <el-input v-model="offRoadForm.emission_stage" clearable placeholder="请输入排放阶段" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="发动机制造厂名称" prop="engine_manufacturer_name">
          <el-input v-model="offRoadForm.engine_manufacturer_name" clearable placeholder="请输入发动机制造厂名称" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发动机型号" prop="engine_model">
          <el-input v-model="offRoadForm.engine_model" clearable placeholder="请输入发动机型号" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="发动机额定净功率(kW)" prop="engine_rated_net_power">
          <el-input v-model="offRoadForm.engine_rated_net_power" clearable placeholder="请输入发动机额定净功率" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发动机额定转速(r/min)" prop="engine_rated_speed">
          <el-input v-model="offRoadForm.engine_rated_speed" clearable placeholder="请输入发动机额定转速" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="发动机后处理器类型" prop="engine_aftertreatment_type">
          <el-input v-model="offRoadForm.engine_aftertreatment_type" clearable placeholder="请输入发动机后处理器类型" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="环保登记号码" prop="env_reg_num">
          <el-input v-model="offRoadForm.env_reg_num" clearable placeholder="请输入环保登记号码" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">检测设备信息</el-divider>
    </el-col>
    <el-row>
      <el-col :span="12">
        <el-form-item label="设备名称" prop="testing_equipment_name">
          <el-input v-model="offRoadForm.testing_equipment_name" clearable placeholder="请输入设备名称" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="设备型号" prop="testing_equipment_model_specification">
          <el-input v-model="offRoadForm.testing_equipment_model_specification" clearable placeholder="请输入设备型号" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="设备生产厂家" prop="testing_equipment_factory">
          <el-input v-model="offRoadForm.testing_equipment_factory" clearable placeholder="请输入设备生产厂家" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="检定/校准有效期至" prop="testing_equipment_calibration_expiry_date">
          <el-date-picker
            v-model="offRoadForm.testing_equipment_calibration_expiry_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择检定/校准有效期至"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">检测现场环境参数</el-divider>
    </el-col>

    <el-row>
      <el-col :span="8">
        <el-form-item label="温度（℃）" prop="temperature">
          <el-input v-model="offRoadForm.temperature" type="number" clearable placeholder="请输入温度" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="湿度（%）" prop="relative_humidity">
          <el-input v-model="offRoadForm.relative_humidity" type="number" clearable placeholder="请输入湿度" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="大气压力（kPa）" prop="atmospheric_pressure">
          <el-input v-model="offRoadForm.atmospheric_pressure" type="number" clearable placeholder="请输入大气压力" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">烟度检验记录</el-divider>
    </el-col>
    <el-row>
      <el-col :span="12">
        <el-form-item label="检测时间" prop="test_time">
          <el-date-picker
            v-model="offRoadForm.test_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择检测时间"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="检测地点" prop="test_location">
          <el-input v-model="offRoadForm.test_location" clearable placeholder="请输入检测地点" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="检测开始时间" prop="test_start_time">
          <el-date-picker
            v-model="offRoadForm.test_start_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择检测开始时间"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="检测结束时间" prop="test_end_time">
          <el-date-picker
            v-model="offRoadForm.test_end_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择检测结束时间"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="所属区域" prop="region">
          <el-input v-model="offRoadForm.region" clearable placeholder="请输入所属区域" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="排气烟度限值（执行类别）" prop="exhaust_smoke_limit">
          <el-input v-model="offRoadForm.exhaust_smoke_limit" clearable placeholder="请输入排气烟度限值" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="检测方法" prop="test_method">
          <el-select v-model="offRoadForm.test_method" placeholder="请选择检测方法">
            <el-option
              v-for="option in options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="实测数值（m⁻¹）1" prop="light_absorption_coefficient_1">
          <el-input v-model="offRoadForm.light_absorption_coefficient_1" type="number" clearable placeholder="请输入实测数值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="实测数值（m⁻¹）2" prop="light_absorption_coefficient_2">
          <el-input v-model="offRoadForm.light_absorption_coefficient_2" type="number" clearable placeholder="请输入实测数值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="实测数值（m⁻¹）3" prop="light_absorption_coefficient_3">
          <el-input v-model="offRoadForm.light_absorption_coefficient_3" type="number" clearable placeholder="请输入实测数值" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="平均值（m⁻¹）" prop="average_value">
          <el-input v-model="offRoadForm.average_value" type="number" clearable placeholder="请输入平均值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="标准限值（m⁻¹）" prop="standard_limit_value">
          <el-input v-model="offRoadForm.standard_limit_value" type="number" clearable placeholder="请输入标准限值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="检测结果" prop="inspection_result">
          <el-radio-group v-model="offRoadForm.inspection_result">
            <el-radio label="合格">合格</el-radio>
            <el-radio label="不合格">不合格</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-divider content-position="center">车辆照片</el-divider>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-form-item label="车辆照片" prop="vehicle_photo">
          <el-upload
            ref="vehicle_photo"
            action=""
            accept="image/*"
            list-type="picture-card"
            limit="4"
            :file-list="fileList"
            :with-credentials="true"
            :before-upload="handleBeforeUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadOnError"
            :http-request="uploadFile"
          >
            <i class="el-icon-plus" />
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" :loading="loading" @click="submit">{{ $t('common.save') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { uploadBase64, upload } from '@/api/common'
import { updateOffRoad, detailOffRoad } from '@/api/check'
import { getToken } from '@/utils/auth'
import { pcTextArr } from 'element-china-area-data'
export default {
  name: 'EditOffRoad',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      id: 0,
      pcTextArr,
      options: [{
        value: '不透光烟度法（自由加速）',
        label: '不透光烟度法（自由加速）'
      }, {
        value: '自由加速法',
        label: '自由加速法'
      }],
      rules: {
        report_id: [
          { required: true, message: '请输入检测报告编号', trigger: 'blur' }
        ],
        machine_owner: [
          { required: true, message: '请输入姓名/单位', trigger: 'blur' }
        ],
        machine_owner_contact: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        machine_owner_address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        product_status: [
          { required: true, message: '请输入机械类型', trigger: 'blur' }
        ],
        model_specification: [
          { required: true, message: '请输入机械型号', trigger: 'blur' }
        ],
        machine_vin_serial: [
          { required: true, message: '请输入机械VIN', trigger: 'blur' }
        ],
        manufacturer: [
          { required: true, message: '请输入生产厂名称', trigger: 'blur' }
        ],
        emission_stage: [
          { required: true, message: '请输入排放阶段', trigger: 'blur' }
        ],
        engine_manufacturer_name: [
          { required: true, message: '请输入发动机制造厂名称', trigger: 'blur' }
        ],
        engine_model: [
          { required: true, message: '请输入发动机型号', trigger: 'blur' }
        ],
        engine_rated_net_power: [
          { required: true, message: '请输入发动机额定净功率(kW)', trigger: 'blur' }
        ],
        engine_rated_speed: [
          { required: true, message: '请输入发动机额定转速(r/min)', trigger: 'blur' }
        ],
        engine_aftertreatment_type: [
          { required: true, message: '请输入发动机后处理器类型', trigger: 'blur' }
        ],
        env_reg_num: [
          { required: true, message: '请输入环保登记号码', trigger: 'blur' }
        ],
        testing_equipment_name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        testing_equipment_model_specification: [
          { required: true, message: '请输入设备型号', trigger: 'blur' }
        ],
        testing_equipment_factory: [
          { required: true, message: '请输入设备生产厂家', trigger: 'blur' }
        ],
        testing_equipment_calibration_expiry_date: [
          { required: true, message: '请输入检定/校准有效期至', trigger: 'blur' }
        ],
        temperature: [
          { required: true, message: '请输入温度', trigger: 'blur' }
        ],
        relative_humidity: [
          { required: true, message: '请输入湿度', trigger: 'blur' }
        ],
        atmospheric_pressure: [
          { required: true, message: '请输入大气压力', trigger: 'blur' }
        ],
        test_time: [
          { required: true, message: '请输入检测时间', trigger: 'blur' }
        ],
        test_location: [
          { required: true, message: '请输入检测地点', trigger: 'blur' }
        ],
        test_start_time: [
          { required: true, message: '请输入检测开始时间', trigger: 'blur' }
        ],
        test_end_time: [
          { required: true, message: '请输入检测结束时间', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请输入所属区域', trigger: 'blur' }
        ],
        exhaust_smoke_limit: [
          { required: true, message: '请输入排气烟度限值（执行类别）', trigger: 'blur' }
        ],
        test_method: [
          { required: true, message: '请输入检测方法', trigger: 'blur' }
        ],
        light_absorption_coefficient_1: [
          { required: true, message: '请输入实测数值（m⁻¹）1', trigger: 'blur' }
        ],
        light_absorption_coefficient_2: [
          { required: true, message: '请输入实测数值（m⁻¹）2', trigger: 'blur' }
        ],
        light_absorption_coefficient_3: [
          { required: true, message: '请输入实测数值（m⁻¹）3', trigger: 'blur' }
        ],
        average_value: [
          { required: true, message: '请输入平均值（m⁻¹）', trigger: 'blur' }
        ],
        standard_limit_value: [
          { required: true, message: '请输入标准限值（m⁻¹）', trigger: 'blur' }
        ],
        inspection_result: [
          { required: true, message: '请输入检测结果', trigger: 'blur' }
        ]
      },
      offRoadForm: {
        report_id: '',
        machine_owner: '',
        machine_owner_contact: '',
        machine_owner_region: [],
        machine_owner_address: '',
        product_status: '',
        model_specification: '',
        manufacture_date: '',
        machine_vin_serial: '',
        manufacturer: '',
        emission_stage: '',
        engine_manufacturer_name: '',
        engine_model: '',
        engine_rated_net_power: '',
        engine_rated_speed: '',
        engine_aftertreatment_type: '',
        env_reg_num: '',
        testing_equipment_name: '',
        testing_equipment_model_specification: '',
        testing_equipment_factory: '',
        testing_equipment_calibration_expiry_date: '',
        temperature: '',
        relative_humidity: '',
        atmospheric_pressure: '',
        test_time: '',
        test_location: '',
        test_start_time: '',
        test_end_time: '',
        region: '',
        exhaust_smoke_limit: '',
        test_method: '',
        light_absorption_coefficient_1: '',
        light_absorption_coefficient_2: '',
        light_absorption_coefficient_3: '',
        average_value: '',
        standard_limit_value: '',
        inspection_result: '',
        vehicle_photo: [],
        user_sign: ''
      },
      fileList: [],
      uploadUrl: process.env.VUE_APP_API + '/common/upload',
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.fetchData(val.id)
        }
      },
      deep: true
    }
  },
  created() {
    const id = this.item.id
    this.id = id
    this.fetchData(id)
  },
  methods: {
    fetchData(id) {
      this.resultImg = ''
      detailOffRoad(id).then(response => {
        this.offRoadForm = response.data
        this.fileList = this.offRoadForm.vehicle_photo.map(item => {
          return {
            name: item,
            url: process.env.VUE_APP_BASE_URL + item
          }
        })
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.offRoadForm.machine_owner_region.length === 0) {
            this.$message.error('请选择联系地址')
            return
          }
          // 车辆照片
          if (this.offRoadForm.vehicle_photo.length === 0) {
            this.$message.error('请上传车辆照片')
            return
          }
          // 签名
          // if (!this.offRoadForm.user_sign) {
          //   this.$message.error('请签名')
          //   return
          // }
          this.loading = true
          updateOffRoad(this.offRoadForm).then(response => {
            this.loading = false
            this.$message.success('保存成功')
            this.$emit('success:edit')
          }).catch(error => {
            console.log(error)
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    handleBeforeUpload(file) {
      // 只要是图片格式就可以上传
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isBMP = file.type === 'image/bmp'
      const isLt2M = file.size / 1024 / 1024 < 6
      if (!(isJPG || isPNG || isGIF || isBMP)) {
        this.$message.error('上传图片只能是 JPG/PNG/GIF/BMP 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 6MB!')
      }
      return (isJPG || isPNG || isGIF || isBMP) && isLt2M
    },
    handleRemove(file) {
      this.offRoadForm.vehicle_photo.splice(this.offRoadForm.vehicle_photo.indexOf(file.url), 1)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadSuccess(response) {
      // 上传成功将返回的图片地址放入form中
      this.offRoadForm.vehicle_photo.push(response.data.path)
    },
    handleUploadOnError() {
      this.$message.error('上传失败')
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    uploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      return upload(formData)
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        uploadBase64({
          file: res
        }).then(response => {
          this.offRoadForm.user_sign = response.data.path
        })
      }).catch(err => {
        alert(err) // 画布没有签字时会执行这里 'Not Signned'
      })
    },
    handleResetSign() {
      this.resultImg = ''
      this.$refs.esign.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-btn {
  margin-top: 10px;
  margin-left: 10px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}
</style>
